import React from 'react';
import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';

const IconButtonComponent = ({ variant, size, color, ...props }) => (
  <IconButton {...props} />
);

const PWDKIconButton = styled(IconButtonComponent)(({ theme, size, color }) => {
  const [colorType, shade] = color.split('.');

  return {
    padding: '8px',
    color: theme.palette[colorType][shade] || theme.palette.neutral100.main,
    backgroundColor: theme.palette.neutral900.main,
    border: `1px solid ${theme.palette.neutral700.main}`,

    '&:hover': {
      backgroundColor: theme.palette.neutral700.main,
    },
    '&:active': {
      backgroundColor: theme.palette.primary500.main,
    },
    '&:disabled': {
      color: theme.palette.neutral500.main,
      backgroundColor: theme.palette.neutral900.main,
    },
  };
});

export default PWDKIconButton;
